import { useIntl } from "react-intl";

import { messages } from "../messages";

export const useErrorPageMessages = () => {
  const { formatMessage } = useIntl();

  return {
    common: {
      buttonText: formatMessage(messages.buttonCommon),
      subtitle: formatMessage(messages.subtitleCommon),
      title: formatMessage(messages.titleCommon),
    },
    notFound: {
      buttonText: formatMessage(messages.buttonHome),
      subtitle: formatMessage(messages.subtitleNotFound),
      title: formatMessage(messages.titleNotFound),
    },
    unexpected: {
      buttonText: formatMessage(messages.buttonRefresh),
      subtitle: formatMessage(messages.subtitleUnexpected),
      title: formatMessage(messages.titleUnexpected),
    },
  };
};
